let selectedOnsiteBookingInputs = [
    {
        id: 'providerBookingInfo',
        label: 'Booking Info',
        type: 'textarea',
        placeholder: 'Booking Info',
        dataPath: 'providerBookingInfo'
    },
    {
        id: 'providerCartInfo',
        label: 'Cart Info',
        type: 'textarea',
        placeholder: 'Cart Info',
        dataPath: 'providerCartInfo'
    }
]

export { selectedOnsiteBookingInputs }